import { Component, OnInit, EventEmitter } from "@angular/core";
import {
  UploadOutput,
  UploadInput,
  UploadFile,
  humanizeBytes,
  UploaderOptions,
} from "ngx-uploader";
import { MessageService, ConfirmationService } from "primeng/api";
import { environment } from "src/environments/environment";
import { Router, ActivatedRoute } from "@angular/router";
import { Sharedservice } from "./../../shared-components/shared.service";
import { UserService } from "./../../services/user.service";
import { EngagementService } from "src/app/services/engagement.service";
import { MasterHelpService } from "../../services/masterhelp.service";
import {
  severitymessage,
  FunctionalityNames,
  LanguageConstants,
} from "../../shared-components/constant";
import { saveAs } from "file-saver";
import { ErrorPopUpModel } from "src/app/models/errorpopup.model";
import { InfraService } from "src/app/services/infra.service";
import { AuditingService } from "src/app/services/auditing.service";
import { LangChangeEvent, TranslateService } from "@ngx-translate/core";
import { AppConfigurationService } from "./../../services/appConfiguration.service";
import { AppConfigurationsModel } from "./../../models/appConfigurations.model";
import { Observable } from "rxjs";

@Component({
  selector: "app-upload-sourcefile",
  templateUrl: "./upload-sourcefile.component.html",
  styleUrls: ["./upload-sourcefile.component.css"],
})
export class UploadSourcefileComponent implements OnInit {
  options: UploaderOptions;
  formData: FormData;
  sourceFiles: UploadFile[];
  isEngagementReadOnly: boolean = false;
  uploadFileList: {
    FileName: string;
    Id: number;
    Status: string;
    Delete: string;
    Download: string;
  }[];
  uploadInput: EventEmitter<UploadInput>;
  humanizeBytes: Function;
  dragOver: boolean;
  doneCount = 0;
  showNextButton = false;
  display = false;
  engagementId = +this.route.snapshot.paramMap.get("id");
  paceId: string;
  cols: any[];
  show = false;
  public pagerows: number;
  uploadInProgressCount = 0;
  loadspinner = false;
  uploadedFilesCount = 0;
  private configUrl: string;
  private maxsize = environment.maxSourceFileSize * 1024 * 1024;
  errorModel: ErrorPopUpModel = new ErrorPopUpModel();
  nextStep: any;
  langCode: string;
  currLangTranslation: any;

  constructor(
    private infraService: InfraService,
    private userService: UserService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private router: Router,
    private sharedService: Sharedservice,
    private engagementService: EngagementService,
    private appConfigService: AppConfigurationService,
    private confirmationService: ConfirmationService,
    private masterHelpService: MasterHelpService,
    private auditService: AuditingService,
    private translateService: TranslateService
  ) {
    this.infraService.infraDetails$.subscribe((data) => {
      this.configUrl =
        data.WebEndPoint2 +
        "DownloadUploadFile/uploadSourceFile/" +
        this.engagementId;
    });

    this.options = {
      concurrency: 1,
      allowedContentTypes: [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel.sheet.macroEnabled.12",
      ],
    };
    this.isEngagementReadOnly =
      this.appConfigService.GetConfigValueByKey("IsProjectsReadOnly");
    this.sourceFiles = []; // local uploading sourceFiles array
    this.uploadInput = new EventEmitter<UploadInput>(); // input events, we use this to emit data to ngx-uploader
    this.humanizeBytes = humanizeBytes;
  }

  onUploadOutput(output: UploadOutput, fileInput: any): void {
    if (!this.isEngagementReadOnly) {
      if (output.type === "allAddedToQueue") {
        // when all sourceFiles added in queue
        // uncomment this if you want to auto upload sourceFiles when added
        if (this.sourceFiles.length > 0) {
          for (const file of this.sourceFiles) {
            const event: UploadInput = {
              type: "uploadFile",
              url: this.configUrl,
              method: "POST",
              file: file,
              headers: {
                Authorization:
                  "Bearer " +
                  (environment.isBearerAuthorizationEnabled
                    ? localStorage["dbamsaltoken"]
                    : environment.sampleToken),
              },
            };
            this.uploadInput.emit(event);
          }
        }
      } else if (
        output.type === "addedToQueue" &&
        typeof output.file !== "undefined"
      ) {
        // add file to array when added
        if (output.file.size > this.maxsize) {
          fileInput.value = "";
          this.errorModel.confirmIsDisplay = true;
          this.errorModel.displayMessage =
            this.currLangTranslation.uploadSourcefilemessage.errorMessage
              .AddError +
            " " +
            output.file.name +
            "  " +
            this.currLangTranslation.uploadSourcefilemessage.errorMessage
              .AddErrorSize +
            environment.maxSourceFileSize +
            " MB";

          this.uploadFileList.push({
            FileName: output.file.name,
            Id: 0,
            Status: this.currLangTranslation.severitymessage.Error,
            Delete:
              this.currLangTranslation.uploadSourcefilemessage.errorMessage
                .AddError +
              " " +
              output.file.name +
              " of size more than " +
              environment.maxSourceFileSize +
              " MB",
            Download: "",
          });
        } else {
          this.sourceFiles.push(output.file);
        }
      } else if (
        output.type === "uploading" &&
        typeof output.file !== "undefined"
      ) {
        if (output.file.size <= this.maxsize) {
          // update current data in sourceFiles array for uploading file
          const index = this.sourceFiles.findIndex(
            (file) =>
              typeof output.file !== "undefined" && file.id === output.file.id
          );
          this.sourceFiles[index] = output.file;

          this.uploadInProgressCount = index + 1;
        }
      } else if (output.type === "done" && typeof output.file !== "undefined") {
        // update current data in sourceFiles array for uploading file
        // this.loadspinner = true;
        if (
          output.file &&
          output.file.response &&
          output.file.response.message === "Invalid File Format"
        ) {
          fileInput.value = "";
          this.uploadInput.emit({ type: "remove", id: output.file.id });
          this.errorModel.confirmIsDisplay = true;
          this.errorModel.displayMessage =
            this.currLangTranslation.uploadSourcefilemessage.errorMessage.FormateError;

          return;
        }
        this.doneCount = this.sourceFiles.filter(
          (subject) => subject.progress.data.percentage > 99
        ).length;
        if (this.doneCount === this.sourceFiles.length) {
          // Add data into auditing table
          this.auditService
            .addAudit(
              this.engagementId,
              FunctionalityNames.UploadSourceFileGenerateAssisted
            )
            .subscribe();
          this.isNextButtonVisible(true);
          this.sourceFiles = [];
        }

        // Clear file - to upload same file name twice
        fileInput.value = "";
        // this.loadspinner = false;
      } else if (
        output.type === "rejected" &&
        typeof output.file !== "undefined"
      ) {
        // Replace with Notification service

        this.errorModel.confirmIsDisplay = true;
        this.errorModel.displayMessage =
          this.currLangTranslation.uploadSourcefilemessage.errorMessage.FormateError;

        this.uploadFileList.push({
          FileName: output.file.name,
          Id: 0,
          Status: this.currLangTranslation.severitymessage.Error,
          Delete:
            this.currLangTranslation.uploadSourcefilemessage.errorMessage
              .FormateError,
          Download: "",
        });
        // this.loadspinner = false;
      } else if (output.type === "removed") {
        // remove file from array when removed

        this.doneCount = this.sourceFiles.filter(
          (subject) => subject.progress.data.percentage > 99
        ).length;
        this.sourceFiles = this.sourceFiles.filter(
          (file: UploadFile) => file !== output.file
        );

        if (this.uploadInProgressCount > 1) {
          this.uploadInProgressCount -= 1;
        }
        // this.loadspinner = false;
      } else if (output.type === "dragOver") {
        this.dragOver = true;
      } else if (output.type === "dragOut") {
        this.dragOver = false;
      } else if (output.type === "drop") {
        this.dragOver = false;
      }
    }
  }
  // end }
  cancelUpload(id: string): void {
    this.uploadInput.emit({ type: "cancel", id: id });
  }

  removeFile(id: string): void {
    this.uploadInput.emit({ type: "remove", id: id });
  }

  removeAllFiles(): void {
    this.uploadInput.emit({ type: "removeAll" });
  }

  ngOnInit() {
    this.langCode = localStorage.getItem(LanguageConstants.LANG_CODE);
    this.currLangTranslation =
      this.translateService.translations[this.langCode];
    this.sharedService.CheckUserAccessForEngagement(this.engagementId);
    this.sharedService.setactiveindex(0);
    this.pagerows = environment.pageRows;
    this.nextStep = this.currLangTranslation.actionButtons.nextStep;

    this.cols = [
      {
        field: "FileName",
        header: "SourceFiles",
        visible: true,
        isEditable: false,
        width: "64%",
        styleClass: "w-64",
      },
      {
        field: "Status",
        header: "Status",
        visible: true,
        isEditable: false,
        width: "10%",
        styleClass: "w-10",
      },
      {
        field: "Download",
        header: "Download",
        visible: true,
        isEditable: false,
        width: "16%",
        styleClass: "w-16",
      },
      {
        field: "Delete",
        header: "Delete",
        visible: true,
        isEditable: false,
        width: "10%",
        styleClass: "w-10",
      },
    ];

    this.isNextButtonVisible();

    this.translateService.onLangChange.subscribe(
      (langEvent: LangChangeEvent) => {
        this.currLangTranslation = langEvent.translations;
        this.nextStep = this.currLangTranslation.actionButtons.nextStep;
      }
    );
  }

  uploadAndPreview() {
    if (this.sourceFiles.length === 0) {
      this.engagementService
        .getsourcefiletabdetails(this.engagementId)
        .subscribe(
          (response: any) => {
            if (response.length > 0) {
              this.loadspinner = true;
              this.sharedService.setactiveindex(1);
              this.loadspinner = false;
              this.router.navigate([
                "/engagement/",
                this.engagementId,
                "previewsourcefile",
              ]);
            } else {
              this.messageService.add({
                key: this.currLangTranslation.severitymessage.key,
                severity: severitymessage.error,
                summary: this.currLangTranslation.severitymessage.notification,
                detail:
                  this.currLangTranslation.uploadSourcefilemessage.errorMessage
                    .Uploaderror,
                sticky: true,
                closable: true,
              });
            }
          },
          (error) => {
            this.messageService.add({
              key: this.currLangTranslation.severitymessage.key,
              severity: severitymessage.error,
              summary: this.currLangTranslation.severitymessage.notification,
              detail:
                this.currLangTranslation.uploadSourcefilemessage.errorMessage
                  .Uploaderror,
              sticky: true,
              closable: true,
            });
          }
        );
    }
    this.messageService.clear();
  }

  isNextButtonVisible(isCalledFromUpload?: boolean) {
    this.loadspinner = true;
    this.engagementService.getUploadedSourceFiles(this.engagementId).subscribe(
      (response: any) => {
        if (response) {
          if (response.status === "error") {
            this.loadspinner = false;
            this.showNextButton = false;
            return;
          }

          if (response.length === 0) {
            this.uploadedFilesCount = 0;
            this.loadspinner = false;
            this.showNextButton = false;
            this.uploadFileList = [];
            if (isCalledFromUpload) {
              this.messageService.add({
                key: this.currLangTranslation.severitymessage.key,
                severity: severitymessage.info,
                summary: this.currLangTranslation.severitymessage.notification,
                detail:
                  this.currLangTranslation.uploadSourcefilemessage.info
                    .EmptyUploadedData,
              });
            }
            return;
          }

          this.showNextButton = true;

          if (response && response.length > 0) {
            this.uploadedFilesCount = response.length;
            this.uploadFileList = <
              {
                FileName: string;
                Id: number;
                Status: string;
                Delete: string;
                Download: string;
              }[]
            >response;
          }
          this.loadspinner = false;
        }
      },
      (error) => {
        this.loadspinner = false;
        this.showNextButton = false;
        this.messageService.add({
          key: this.currLangTranslation.severitymessage.key,
          severity: severitymessage.error,
          summary: this.currLangTranslation.severitymessage.notification,
          detail: this.currLangTranslation.severitymessage.somethingwrong,
          life: 10000,
        });
      }
    );
  }

  downloadFilefromSource(sourceId: number, fileName: string) {
    this.loadspinner = true;
    this.engagementService
      .downloadSourceFileFromAzureStorage(sourceId, this.engagementId)
      .subscribe(
        (blobData) => {
          if (blobData) {
            saveAs(blobData, fileName);
            this.loadspinner = false;
          }
        },
        (error) => {
          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key,
            severity: severitymessage.error,
            summary: this.currLangTranslation.severitymessage.notification,
            detail:
              this.currLangTranslation.uploadSourcefilemessage.errorMessage
                .DownloadError,
            life: 10000,
          });
        }
      );
  }

  downloadAllFilefromSource() {
    if (this.uploadFileList.length > 0) {
      this.loadspinner = true;
      let zipSourceFileName = "";
      this.engagementService
        .getEngagement(this.engagementId)
        .subscribe((data) => {
          if (data !== null) {
            this.paceId = data.PaceId;
            zipSourceFileName = this.paceId + "_AllSourceFiles.zip";
          }
        });

      this.engagementService
        .downloadAllSourceFileFromAzureStorage(this.engagementId)
        .subscribe(
          (blobData) => {
            if (blobData) {
              saveAs(blobData, zipSourceFileName);
              this.loadspinner = false;
            }
          },
          (error) => {
            this.messageService.add({
              key: this.currLangTranslation.severitymessage.key,
              severity: severitymessage.error,
              summary: this.currLangTranslation.severitymessage.notification,
              detail:
                this.currLangTranslation.uploadSourcefilemessage.errorMessage
                  .DownloadError,
              life: 10000,
            });
          }
        );
    }
  }

  deletesource(sourceId: number, fileName: string) {
    if (!this.isEngagementReadOnly) {
      this.loadspinner = true;
      this.engagementService.checkExistance(sourceId).subscribe(
        (response: any) => {
          this.loadspinner = false;
          if (response.status === false) {
            this.confirmationService.confirm({
              message:
                this.currLangTranslation.uploadSourcefilemessage.confirmMessage
                  .Confirm,
              header: this.currLangTranslation.labels.warning,
              acceptLabel: this.currLangTranslation.actionButtons.yes,
              rejectLabel: this.currLangTranslation.actionButtons.no,
              accept: () => {
                this.loadspinner = true;
                this.engagementService
                  .deleteSourceFileData(sourceId, fileName, this.engagementId)
                  .subscribe(
                    (response: any) => {
                      this.isNextButtonVisible();
                      this.messageService.add({
                        key: this.currLangTranslation.severitymessage.key,
                        severity: severitymessage.success,
                        summary:
                          this.currLangTranslation.severitymessage.notification,
                        detail:
                          this.currLangTranslation.uploadSourcefilemessage
                            .successMessage.Delete,
                        sticky: true,
                        closable: true,
                      });
                      this.loadspinner = false;
                    },
                    (error) => {
                      this.messageService.add({
                        key: this.currLangTranslation.severitymessage.key,
                        severity: severitymessage.error,
                        summary:
                          this.currLangTranslation.severitymessage.notification,
                        detail:
                          this.currLangTranslation.uploadSourcefilemessage
                            .errorMessage.DeleteError,
                        sticky: true,
                        closable: true,
                      });
                      this.loadspinner = false;
                    }
                  );
              },
              reject: () => {},
            });
          } else {
            this.confirmationService.confirm({
              message:
                this.currLangTranslation.uploadSourcefilemessage.confirmMessage
                  .confirmDelete,
              header: this.currLangTranslation.labels.confirmation,
              acceptLabel: this.currLangTranslation.actionButtons.yes,
              rejectLabel: this.currLangTranslation.actionButtons.no,
              accept: () => {
                this.loadspinner = true;
                this.engagementService
                  .deleteSourceFileData(sourceId, fileName, this.engagementId)
                  .subscribe(
                    (response: any) => {
                      this.isNextButtonVisible();
                      this.messageService.add({
                        key: this.currLangTranslation.severitymessage.key,
                        severity: severitymessage.success,
                        summary:
                          this.currLangTranslation.severitymessage.notification,
                        detail:
                          this.currLangTranslation.uploadSourcefilemessage
                            .successMessage.Delete,
                        sticky: true,
                        closable: true,
                      });
                      this.loadspinner = false;
                    },
                    (error) => {
                      this.messageService.add({
                        key: this.currLangTranslation.severitymessage.key,
                        severity: severitymessage.error,
                        summary:
                          this.currLangTranslation.severitymessage.notification,
                        detail:
                          this.currLangTranslation.uploadSourcefilemessage
                            .errorMessage.DeleteError,
                        sticky: true,
                        closable: true,
                      });
                      this.loadspinner = false;
                    }
                  );
              },
              reject: () => {},
            });
          }
        },
        (error) => {
          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key,
            severity: severitymessage.error,
            summary: this.currLangTranslation.severitymessage.notification,
            detail:
              this.currLangTranslation.uploadSourcefilemessage.errorMessage
                .DeleteError,
            sticky: true,
            closable: true,
          });
        }
      );
    }
  }
  deletesourcefiles() {
    if (this.uploadFileList.length > 0 && !this.isEngagementReadOnly) {
      this.confirmationService.confirm({
        message:
          this.currLangTranslation.uploadSourcefilemessage.confirmMessage
            .ConfirmDeleteAll,
        header: this.currLangTranslation.labels.warning,
        acceptLabel: this.currLangTranslation.actionButtons.yes,
        rejectLabel: this.currLangTranslation.actionButtons.no,
        accept: () => {
          this.loadspinner = true;
          this.engagementService
            .deleteAllSourceFiles(this.engagementId)
            .subscribe(
              (response: any) => {
                this.isNextButtonVisible();
                this.messageService.add({
                  key: this.currLangTranslation.severitymessage.key,
                  severity: severitymessage.success,
                  summary:
                    this.currLangTranslation.severitymessage.notification,
                  detail:
                    this.currLangTranslation.uploadSourcefilemessage
                      .successMessage.Delete,
                  sticky: true,
                  closable: true,
                });
                this.loadspinner = false;
              },
              (error) => {
                this.messageService.add({
                  key: this.currLangTranslation.severitymessage.key,
                  severity: severitymessage.error,
                  summary:
                    this.currLangTranslation.severitymessage.notification,
                  detail:
                    this.currLangTranslation.uploadSourcefilemessage
                      .errorMessage.DeleteError,
                  sticky: true,
                  closable: true,
                });
                this.loadspinner = false;
              }
            );
        },
        reject: () => {},
      });
    }
  }
  confirmdisplay = false;
  closeEventworkallocation($event) {
    this.confirmdisplay = $event;
  }

  okEventworkallocation($event) {
    this.confirmdisplay = false;
  }

  cancelDatabook() {
    this.confirmdisplay = true;
  }

  showFailedSourcefileUpload() {
    if (this.sourceFiles.length !== 0) {
      const fnamelist = new Array();
      for (let i = 0; i < this.sourceFiles.length; i++) {
        let checkFlag = false;
        let filename = "";
        for (let k = 0; k < this.uploadFileList.length; k++) {
          if (this.sourceFiles[i].name === this.uploadFileList[k].FileName) {
            checkFlag = true;
            filename = this.sourceFiles[i].name;
          } else {
            filename = this.sourceFiles[i].name;
            checkFlag = false;
          }
        }

        if (checkFlag === false) {
          fnamelist.push(filename);
        }
      }

      if (fnamelist.length > 0) {
        for (let j = 0; j < fnamelist.length; j++) {
          this.uploadFileList.push({
            FileName: fnamelist[j],
            Id: 0,
            Status: this.currLangTranslation.severitymessage.Error,
            Delete: "No",
            Download: "",
          });
        }
      }
    }
  }
}
